import axios from 'axios';
const getExternalGameProfiles = async (ugrId) => {
    const response = await axios.get(`${process.env.REPEAT_TOURNAMENT_SERVICE_URL}/lobby-tournament/v1/lobby-tournament/user-game-region/${ugrId}/external/game-profiles`);
    return response.data;
};
export default getExternalGameProfiles;
